import Button from 'core/modules/atoms/Button';
import { Icon } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const LessonSelectedCard = ({ lesson, onRemove, disabled, isLoadingContent, error }) => {
  const { t } = useTranslation(['chatbot', 'actions']);
  if (!lesson) {
    return null;
  }

  const handleRemove = () => {
    onRemove(lesson.guid || lesson.lessonGuid);
  };

  return (
    <>
      <div className={`lesson-selected-card ${error ? 'lesson-selected-card__error' : ''}`}>
        <div className="lesson-selected-card__content">
          <div className="lesson-selected-card__content-wrapper">
            <div className="lesson-selected-card__icon-wrapper">
              <Icon name="doc" color="white" />
            </div>

            <div className="lesson-selected-card__info">
              <div className="lesson-selected-card__title" dangerouslySetInnerHTML={{ __html: lesson.title }} />
              <p className="lesson-selected-card__meta">
                {isLoadingContent ? (
                  <span className="lesson-selected-card__loading">{t('chatbot:Loading...')}</span>
                ) : (
                  <>
                    {lesson.wordCount || 0} {t('chatbot:words')}
                  </>
                )}
              </p>
            </div>
          </div>

          {!disabled && (
            <div className="lesson-selected-card__remove-button">
              <Button onlyIcon={true} icon="close" color="grey-secondary" size="xs" onClick={handleRemove} ariaLabel={t('actions:Remove')} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

LessonSelectedCard.propTypes = {
  lesson: PropTypes.shape({
    guid: PropTypes.string,
    lessonGuid: PropTypes.string,
    title: PropTypes.string,
    wordCount: PropTypes.number,
    courseName: PropTypes.string,
    unitName: PropTypes.string,
  }),
  onRemove: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isLoadingContent: PropTypes.bool,
  error: PropTypes.string,
};

LessonSelectedCard.defaultProps = {
  disabled: false,
  lesson: null,
  isLoadingContent: false,
  error: null,
};

export default LessonSelectedCard;
